//
// Copyright (c) 2026 Comcast
//

// This function copies content of table for excel document
export function copyTable (tableId) {
  const elTable = document.getElementById(tableId)

  let range, sel

  if (document.createRange && window.getSelection) {
    range = document.createRange()
    sel = window.getSelection()
    sel.removeAllRanges()

    try {
      range.selectNodeContents(elTable)
      sel.addRange(range)
    } catch (e) {
      range.selectNode(elTable)
      sel.addRange(range)
    }

    document.execCommand('copy')
  }

  sel.removeAllRanges()
}
